/**
 * set of NSIdentity
 * @param  {NSIdentity[]} array [description]
 * @return {NSSet}              [description]
 */
export default class NSSet {
    constructor(content) {
        this._content = {};
        if (content) {
            this.pushArray(content);
        }
    }
    static fromArray(array) {
        const nSet = new NSSet();
        nSet.pushArray(array);
        return nSet;
    }
    push(item) {
        if (!this._content[item.fqn]) {
            this._content[item.fqn] = item;
            return true;
        }
        return false;
    }
    pushArray(item) {
        item.forEach(v => {
            this.push(v);
        });
        return this;
    }
    toArray() {
        const ret = [];
        for (let key in this._content) {
            ret.push(this._content[key]);
        }
        return ret;
    }
    clone() {
        const newSet = new NSSet();
        for (let key in this._content) {
            newSet.push(this._content[key]);
        }
        return newSet;
    }
    merge(other) {
        this.pushArray(other.toArray());
        return this;
    }
    forEach(func) {
        for (let key in this._content) {
            func(this._content[key]);
        }
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/Base/NSSet.ts